import styled from 'styled-components';
import SupportButton from './SupportButton';
import { colorSchema } from 'utils/style';

export default styled(SupportButton)`
  align-items: center;
  display: flex;
  justify-content: center;

  .support-button {
    display: flex;

    &__button {
      background: transparent;
      color: ${colorSchema('primary')};
      cursor: pointer;
      display: inline-block;
      border: solid ${colorSchema('primary')};
      max-width: 100%;
      text-transform: none;
      height: 4rem;
      font-size: 1.4rem;
      border-radius: 0.8rem;
      border-width: 0.2rem;
      padding: 0 1.6rem;
      font-weight: 500;
      outline: none;
      text-decoration: none;
      vertical-align: middle;

      &:hover {
        background: ${colorSchema('primary')};
        color: ${colorSchema('white')};

        .support-button__icon {
          fill: ${colorSchema('white')};

          &--loading {
            stroke: ${colorSchema('white')};
          }
        }
      }

      &:disabled {
        opacity: 0.5;
      }
    }

    &__container {
      align-items: center;
      display: flex;
    }

    &__icon {
      fill: ${colorSchema('primary')};
      margin: 0;
      margin-right: 0.5rem;
      width: 14px;

      &--loading {
        animation: rotate 1s infinite linear;
        height: 16px;
        stroke: ${colorSchema('primary')};
        width: 16px;
      }
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;
